var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-3"},_vm._l((_vm.allOptions),function(option){return _c('v-row',{key:option},[_c('v-checkbox',{attrs:{"label":option,"disabled":!_vm.editable,"input-value":_vm.inputValue(option)},on:{"change":function($event){return _vm.onChange($event, option)}}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }